var displayOnMultiSelectFilter = function () {
    return function (input) {
        var output = input;
        if (output.length > 22) {
            return output.substring(0, 22) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = displayOnMultiSelectFilter;
export var DisplayOnMultiSelectFilter = {
    name: 'displayOnMultiSelectFilter',
    filter: displayOnMultiSelectFilter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-display-on-multi-select.filter.js.map